// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cTAKl","content":"styles_content__1KhFk","tableWrap":"styles_tableWrap__3mm2i"};